/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getGa4DashboardV1QuerySchema = z.object({
  period: z.enum(['7d', '30d', 'all']).default('7d'),
  refresh: z.coerce.boolean().optional(),
});

export type IGetGa4DashboardV1Query = z.input<typeof getGa4DashboardV1QuerySchema>;
